import React, { Component, useState } from "react";
import { SiHackthebox } from "react-icons/si";
import { TbReportAnalytics } from "react-icons/tb";
import { TbPackage } from "react-icons/tb";
import { RiFeedbackLine, RiCoupon5Line } from "react-icons/ri";
import { TbReceiptTax, TbBuildingStore } from "react-icons/tb";
import { BsFillCartCheckFill } from "react-icons/bs";
import { TiCloudStorage } from "react-icons/ti";
import { SiDatabricks } from "react-icons/si";
import { MdSoupKitchen } from "react-icons/md";
import { MdDashboard } from "react-icons/md";
import { GoListOrdered } from "react-icons/go";
import CartContext from "./CartContext";
import {
  FaHouseDamage,
  FaBuysellads,
  FaUserShield,
  FaUserFriends,
  FaClipboardList,
  FaTags,
} from "react-icons/fa";
import { BsFillPeopleFill } from "react-icons/bs";
import { TbPackages } from "react-icons/tb";
import { SiCoinmarketcap } from "react-icons/si";
import { FaProjectDiagram } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { FaUsers } from "react-icons/fa6";
import { FaFileInvoice } from "react-icons/fa";
import { BsFillCalendarFill } from "react-icons/bs";
import { PiListNumbersFill } from "react-icons/pi";
import { BiSolidQuoteRight } from "react-icons/bi";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { SiCommerzbank } from "react-icons/si";
import { FcSelfServiceKiosk } from "react-icons/fc";

import {
  Row,
  Col,
  Accordion,
  Button,
  Nav,
  ListGroup,
  Badge,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { FcSalesPerformance } from "react-icons/fc";
import UserRoles from "./CartContext";
import { LiaFirstOrder } from "react-icons/lia";
import { GrServices } from "react-icons/gr";
import { FcWorkflow } from "react-icons/fc";
import { BiBarChart, BiSolidPurchaseTag } from "react-icons/bi";

import {
  BsFillBagFill,
  BsFullscreen,
  BsArrowRight,
  BsTruck,
  BsCashCoin,
  BsDoorClosed,
  BsClockHistory,
  BsArrowReturnLeft,
  BsUiChecksGrid,
  BsCardList,
  BsPeopleFill,
  BsBoundingBox,
  BsFillCameraFill,
  BsFillFileImageFill,
  BsFillLaptopFill,
  BsDiagram3,
  BsPersonSquare,
  BsAward,
  BsMenuDown,
  BsPersonCheckFill,
  BsZoomOut,
} from "react-icons/bs";

export class SideMenu extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      productDefaultActiveKey: "1",
      customerDefaultActiveKey: "1",
      marketingDefaultActiveKey: "1",
    };
  }

  componentDidMount() {
    console.log("called");
  }

  showMainDashboard = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showMainReports = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  showSuppliers = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.PRODUCTPURCHASEMANAGER ==
        this.context.userData.roleId ||
      this.context.UserRoles.RAWMATERIALSINVENTORYMANAGER ==
        this.context.userData.roleId ||
      this.context.UserRoles.SUPPLIER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showWarehouse = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  showRmInventory = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.RAWMATERIALSINVENTORYMANAGER ==
        this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showManufacturer = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.RAWMATERIALSINVENTORYMANAGER ==
        this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showProductInventory = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.PRODUCTPURCHASEMANAGER ==
        this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showServicing = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.SERVICINGMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showMarketing = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showSales = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.ORDERS == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  showCrm = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      // this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      // this.context.UserRoles.ORDERS == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showHrm = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.HRMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showProjects = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.HRMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.PROJECTMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showAccounts = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.ACCOUNTINGMANAGER ==
        this.context.userData.roleId ||
      this.context.UserRoles.ACCOUNTINGEMPLOYEE == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  showOrders = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.ORDERS == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId ||
      this.context.UserRoles.ORDERS == this.context.userData.roleId ||
      this.context.UserRoles.PACKAGING == this.context.userData.roleId ||
      this.context.UserRoles.DELIVERY == this.context.userData.roleId ||
      this.context.UserRoles.PAYMENT == this.context.userData.roleId ||
      this.context.UserRoles.RETURNS == this.context.userData.roleId ||
      this.context.UserRoles.SHIPPING == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  enablePortalSettingsMenu = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  ShowStorage = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  ShowAdminMenu = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  ShowProductAdminMenu = () => {
    if (this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId) {
      return true;
    } else {
      return false;
    }
  };
  showHotel = () => {
    return false;
  };

  render() {
    if (this.context.userData.loginStatus != "active") return;
    return (
      <div
        className="border"
        style={{
          backgroundColor: "white",
          paddingLeft: "0px",
          paddingRight: "0px",
        }}
      >
        <div
          className="bg-white overflow-scroll "
          style={{
            overflowY: "scroll",
            height: window.innerHeight - 50 + "px",
            // height: window.innerHeight * 5 + "px",
          }}
        >
          <div className="text-end position-sticky fixed-top">
            <Button
              variant="dark"
              className="rounded-circle"
              onClick={(e) => this.props.showSideBar(false)}
            >
              &lt;&lt;
            </Button>
          </div>

          {/* Dashboard */}
          {this.showMainDashboard() ? (
            <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
              <Nav.Link
                as={Link}
                style={{
                  fontSize: "12px",
                  fontFamily: "tahoma",
                  fontWeight: "bold",
                }}
                className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                to="/HomeDashboard"
                onClick={(e) => {
                  this.context.selectedMenuItem = "dashboard";
                }}
              >
                <MdDashboard size={20} />
                &nbsp;Dashboard
              </Nav.Link>
            </ListGroup.Item>
          ) : (
            <></>
          )}

          {/* Reports */}
          {this.showMainReports() ? (
            <>
              <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                <Nav.Link
                  as={Link}
                  style={{
                    color: "black",
                    fontSize: "12px",
                    fontFamily: "tahoma",
                    fontWeight: "bold",
                  }}
                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-dark text-start"
                  to="/Reports"
                >
                  <TbReportAnalytics size="22" />
                  &nbsp;Reports
                </Nav.Link>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}

          {/* Warehouse */}
          {this.showWarehouse() ? (
            <>
              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                <Nav.Link
                  as={Link}
                  style={{
                    fontSize: "12px",
                    fontFamily: "tahoma",
                    fontWeight: "bold",
                  }}
                  className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                  to="/Warehouse"
                >
                  <FaHouseDamage size="20" />
                  &nbsp;Warehouses
                </Nav.Link>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}

          {/* HOTEL */}
          {this.showHotel() ? (
            <ListGroup.Item className="px-0 py-0 mx-0 my-0">
              <Accordion
                defaultActiveKey="1"
                className="mx-0 px-0 py-0 my-0 mb-0 border-0"
              >
                <Accordion.Item
                  eventKey={
                    this.context.selectedMenuItem === "Hotel" ? "1" : "0"
                  }
                  className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                  onClick={(e) => {
                    this.context.selectedMenuItem = "Hotel";
                  }}
                >
                  <Accordion.Header className="mx-0 p-lg-0  text-start">
                    <Nav.Link
                      as={Link}
                      className="p-lg-0 bg-white border-0 text-dark text-start"
                      style={{
                        fontSize: "12px",
                        fontFamily: "tahoma",
                        fontWeight: "bold",
                      }}
                      to=""
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-boxes"
                        viewBox="0 0 16 16"
                      >
                        <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z" />
                      </svg>
                      &nbsp;Hotel
                    </Nav.Link>
                  </Accordion.Header>
                  <Accordion.Body>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelGuestManager"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Guests
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelRoomStatus"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Room Status
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelRoomTypes"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Room Types
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelRoom"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Rooms
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelRatePlan"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Rate Planner
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelReservation"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Reservation
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelBookingCalendar"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Booking Calendar
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelFolio"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Folios
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelPayment"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Hotel Payments
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelHousekeepingTask"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Hotel Management Tasks
                      </Nav.Link>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/HotelMaintenanceTicket"
                      >
                        <BsUiChecksGrid size="20" />
                        &nbsp; Maintenance Ticket
                      </Nav.Link>
                    </ListGroup.Item>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </ListGroup.Item>
          ) : (
            <></>
          )}

          {/* Suppliers */}
          {this.showSuppliers() ? (
            <>
              <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                <Accordion
                  defaultActiveKey="1"
                  className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                >
                  <Accordion.Item
                    eventKey={
                      this.context.selectedMenuItem === "Suppliers" ? "1" : "0"
                    }
                    className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                    onClick={(e) => {
                      this.context.selectedMenuItem = "Suppliers";
                    }}
                  >
                    <Accordion.Header className="mx-0 p-lg-0  text-start">
                      <Nav.Link
                        as={Link}
                        className="p-lg-0 bg-white border-0 text-dark text-start"
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        to=""
                      >
                        {/* <TbPackage size="20"></TbPackage> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-boxes"
                          viewBox="0 0 16 16"
                        >
                          <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z" />
                        </svg>
                        {this.context.store.businessTypeId == 3 ? (
                          <>&nbsp;Supplier </>
                        ) : (
                          <>&nbsp;Supplier </>
                        )}
                      </Nav.Link>
                    </Accordion.Header>
                    <Accordion.Body>
                      {this.context.userData.roleId ==
                      this.context.UserRoles.SUPPLIER ? (
                        <></>
                      ) : (
                        <>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                              to="/Suppliers"
                            >
                              <FiUsers size={20} />
                              &nbsp; Suppliers
                            </Nav.Link>
                          </ListGroup.Item>
                        </>
                      )}

                      {this.context.storeSettings.showSuppliersManagement ==
                      true ? (
                        <>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                              to="/SupplierInventory"
                            >
                              <BsUiChecksGrid size="20" />
                              &nbsp; Inventory
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                              to="/SupplierPurchaseOrdersIndent"
                            >
                              <PiListNumbersFill size="20" />
                              &nbsp; Order Received
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                              to="/SupplierDispatches"
                            >
                              <BsTruck size="20" />
                              &nbsp; Order Dispatched
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                              to="/SupplierPurchaseOrderInward"
                            >
                              <FaHouseDamage size="20" />
                              &nbsp; Order Delivered
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                              to="/SupplierPayments"
                            >
                              <BsCashCoin size="20" />
                              &nbsp; Payments Received
                            </Nav.Link>
                          </ListGroup.Item>
                        </>
                      ) : (
                        <></>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}

          {/* RawMaterials Inventory*/}
          {this.showRmInventory() &&
          (this.context.storeSettings.isManufacturer == true ||
            this.context.storeSettings.isServiceManagementBusiness == true) ? (
            <>
              <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                <Accordion
                  defaultActiveKey="1"
                  className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                >
                  <Accordion.Item
                    eventKey={
                      this.context.selectedMenuItem === "kitchen" ? "1" : "0"
                    }
                    className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                    onClick={(e) => {
                      this.context.selectedMenuItem = "kitchen";
                    }}
                  >
                    <Accordion.Header className="mx-0 p-lg-0  text-start">
                      <Nav.Link
                        as={Link}
                        className="p-lg-0 bg-white border-0 text-dark text-start"
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        to=""
                      >
                        {/* <TbPackage size="20"></TbPackage> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-boxes"
                          viewBox="0 0 16 16"
                        >
                          <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z" />
                        </svg>
                        {this.context.store.businessTypeId == 3 ? (
                          <>&nbsp;RawMaterials </>
                        ) : (
                          <>&nbsp;RawMaterials </>
                        )}
                      </Nav.Link>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/RawMaterialCategory"
                        >
                          <RiCoupon5Line size="20" />
                          &nbsp;RM Categories
                        </Nav.Link>
                      </ListGroup.Item>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/RawMaterialIndent"
                        >
                          <RiCoupon5Line size="20" />
                          &nbsp;RM Purchase Order[INDENT]
                        </Nav.Link>
                      </ListGroup.Item>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/RawMaterialPendingPurchaseItems"
                        >
                          <RiCoupon5Line size="20" />
                          &nbsp;Pending Purchase Items
                        </Nav.Link>
                      </ListGroup.Item>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/RawMaterialInward"
                        >
                          <RiCoupon5Line size="20" />
                          &nbsp;RM Purchase Order[INWARD]
                        </Nav.Link>
                      </ListGroup.Item>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/RawMaterialsInventory"
                        >
                          <RiCoupon5Line size="20" />
                          &nbsp;RM Inventory
                        </Nav.Link>
                      </ListGroup.Item>

                      {this.context.store.businessTypeId == 3 ? (
                        <></>
                      ) : (
                        <>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/RawMaterialManufacturingRequest"
                            >
                              <RiCoupon5Line size="20" />
                              &nbsp;Production Requests
                            </Nav.Link>
                          </ListGroup.Item>

                          {this.context.storeSettings
                            .isServiceManagementBusiness == true ? (
                            <>
                              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                <Nav.Link
                                  as={Link}
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "tahoma",
                                    fontWeight: "bold",
                                  }}
                                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                  to="/RawMaterialServiceRequest"
                                >
                                  <RiCoupon5Line size="20" />
                                  &nbsp;Servicing Requests
                                </Nav.Link>
                              </ListGroup.Item>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/RawMaterialsOutOfStock"
                        >
                          <RiCoupon5Line size="20" />
                          &nbsp;In-Stock Checker
                        </Nav.Link>
                      </ListGroup.Item>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}

          {/* Manufacture */}
          {this.showManufacturer() ? (
            <>
              {this.context.storeSettings.isManufacturer == true ? (
                <>
                  <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                    <Accordion
                      defaultActiveKey="1"
                      className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                    >
                      <Accordion.Item
                        eventKey={
                          this.context.selectedMenuItem === "manufacture"
                            ? "1"
                            : "0"
                        }
                        className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "manufacture";
                        }}
                      >
                        <Accordion.Header className="mx-0 p-lg-0  text-start">
                          <Nav.Link
                            className="p-lg-0 bg-white border-0 text-dark text-start"
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            to=""
                          >
                            {/* <BsFillCartCheckFill size="20" /> */}

                            {this.context.store.businessTypeId == 3 ? (
                              <>
                                <MdSoupKitchen size="20" />
                                &nbsp;Kitchen{" "}
                              </>
                            ) : (
                              <>
                                <FcWorkflow size="20" />
                                &nbsp;Production
                              </>
                            )}
                          </Nav.Link>
                        </Accordion.Header>
                        <Accordion.Body className="text-secondary">
                          {this.context.store.businessTypeId == 3 ? (
                            <></>
                          ) : (
                            <>
                              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                <Nav.Link
                                  as={Link}
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "tahoma",
                                    fontWeight: "bold",
                                  }}
                                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                  to="/ManufacturingRequestOrders"
                                >
                                  <RiCoupon5Line size="20" />
                                  &nbsp;Production Work Orders
                                </Nav.Link>
                              </ListGroup.Item>
                              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                <Nav.Link
                                  as={Link}
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "tahoma",
                                    fontWeight: "bold",
                                  }}
                                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                  to="/ManufacturingTasks"
                                >
                                  <RiCoupon5Line size="20" />
                                  &nbsp;Production Tasks
                                </Nav.Link>
                              </ListGroup.Item>
                            </>
                          )}

                          <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                            <Nav.Link
                              as={Link}
                              style={{
                                color: "black",
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/Recipes"
                            >
                              <RiCoupon5Line size="20" />
                              {this.context.store.businessTypeId == 3 ? (
                                <>&nbsp;Recipes & Estimation</>
                              ) : (
                                <>&nbsp;Product Costing & Making Procedures</>
                              )}
                            </Nav.Link>
                          </ListGroup.Item>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ListGroup.Item>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          {/* Product Inventory */}
          {this.showProductInventory() ? (
            <>
              {this.context.storeSettings.showProductInventoryModule == true ||
              this.context.storeSettings.showProductInventoryModule ==
                undefined ? (
                <>
                  <ListGroup.Item className="px-0 py-0 m-0 ">
                    <Accordion
                      defaultActiveKey="1"
                      className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                    >
                      <Accordion.Item
                        eventKey={
                          this.context.selectedMenuItem === "product"
                            ? "1"
                            : "0"
                        }
                        className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                        onClick={(e) => {
                          e.eventKey = "1";
                          this.context.selectedMenuItem = "product";
                          //this.context.UpdateSelectedMenuItem("product");
                        }}
                      >
                        <Accordion.Header className="mx-0 p-lg-0  text-start">
                          <Nav.Link
                            as={Link}
                            className="m-0 p-0 p-lg-0 bg-white border-0 text-dark text-start"
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            to=""
                            onClick={(e) =>
                              this.setState({
                                productDefaultActiveKey: 0,
                              })
                            }
                          >
                            {/* <BsCardList size="20" /> */}
                            <TbPackages size="20"></TbPackages>
                            &nbsp;Products
                          </Nav.Link>
                        </Accordion.Header>
                        <Accordion.Body>
                          <ListGroup variant="flush" className="bg-black">
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className=" menubutton w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                                to="/StorageTankManager"
                              >
                                <BsDiagram3 size="20" />
                                &nbsp;Product WH Units
                              </Nav.Link>
                            </ListGroup.Item>

                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className=" menubutton w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                                to="/Category"
                              >
                                <BsDiagram3 size="20" />
                                &nbsp;Product Category
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                to="/ProductIndent"
                              >
                                <RiCoupon5Line size="20" />
                                &nbsp;Purchase Order[INDENT]
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                to="/ProductPendingPurchaseItems"
                              >
                                <RiCoupon5Line size="20" />
                                &nbsp;Pending Purchase Items
                              </Nav.Link>
                            </ListGroup.Item>

                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                to="/ProductInward"
                              >
                                <RiCoupon5Line size="20" />
                                &nbsp;Purchase Order[INWARD]
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                                to="/ProductSellingPriceRuleManager"
                              >
                                <BsUiChecksGrid size="20" />
                                &nbsp;Selling Price Rules
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                                to="/Product"
                              >
                                <BsUiChecksGrid size="20" />
                                &nbsp;Product Inventory
                              </Nav.Link>
                            </ListGroup.Item>

                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                                to="/OutOfStock"
                              >
                                <BsZoomOut size="20" />
                                &nbsp;In-Stock Checker
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className=" menubutton w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                                to="/LiveFishMovement"
                              >
                                <BsDiagram3 size="20" />
                                &nbsp;Stock Movement
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                to="/Brands"
                              >
                                <BsAward size="20" />
                                &nbsp;Brands
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                to="/DataTypes"
                              >
                                <SiDatabricks size="20" />
                                &nbsp;DataTypes
                              </Nav.Link>
                            </ListGroup.Item>

                            {this.context.storeSettings.showEcommerceModule ==
                              true ||
                            this.context.storeSettings.showEcommerceModule ==
                              undefined ? (
                              <>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link
                                    as={Link}
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "tahoma",
                                      fontWeight: "bold",
                                    }}
                                    className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                                    to="/ProductGroups"
                                  >
                                    <BsBoundingBox size="20" />
                                    &nbsp;Product Groups
                                  </Nav.Link>
                                </ListGroup.Item>
                              </>
                            ) : (
                              <></>
                            )}

                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                style={{
                                  fontSize: "12px",
                                  fontFamily: "tahoma",
                                  fontWeight: "bold",
                                }}
                                className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                to="/BarCodeCustom"
                              >
                                <BsFillCameraFill size="20" />
                                &nbsp;BarCode Creator
                              </Nav.Link>
                            </ListGroup.Item>
                          </ListGroup>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ListGroup.Item>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          {/* Servicing */}
          {this.showServicing() ? (
            <>
              {this.context.storeSettings.isServiceManagementBusiness ==
              true ? (
                <>
                  <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                    <Accordion
                      defaultActiveKey="1"
                      className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                    >
                      <Accordion.Item
                        eventKey={
                          this.context.selectedMenuItem === "servicing"
                            ? "1"
                            : "0"
                        }
                        className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "servicing";
                        }}
                      >
                        <Accordion.Header className="mx-0 p-lg-0  text-start">
                          <Nav.Link
                            className="p-lg-0 bg-white border-0 text-dark text-start"
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            to=""
                          >
                            {/* <BsFillCartCheckFill size="20" /> */}
                            {/* <TbPackage size="20"></TbPackage> */}
                            <GrServices size="20" />
                            {this.context.store.businessTypeId == 3 ? (
                              <></>
                            ) : (
                              <>&nbsp;Servicing(CRM)</>
                            )}
                          </Nav.Link>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Nav.Link
                            as={Link}
                            style={{
                              color: "black",
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/ProductServiceCustomers"
                          >
                            <RiCoupon5Line size="20" />
                            &nbsp;Customers DB
                          </Nav.Link>
                          <Nav.Link
                            as={Link}
                            style={{
                              color: "black",
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/ProductServiceBookings"
                          >
                            <RiCoupon5Line size="20" />
                            &nbsp;Service Booking
                          </Nav.Link>
                          <Nav.Link
                            as={Link}
                            style={{
                              color: "black",
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/ProductServiceTaskInventory"
                          >
                            <RiCoupon5Line size="20" />
                            <>&nbsp;Serivicing Tasks Inventory</>
                          </Nav.Link>

                          <Nav.Link
                            as={Link}
                            style={{
                              color: "black",
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/ProductServiceRequests"
                          >
                            <RiCoupon5Line size="20" />
                            &nbsp;Servicing Order
                          </Nav.Link>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ListGroup.Item>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          {/* Marketing */}
          {this.showMarketing() ? (
            <>
              <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                <Accordion
                  defaultActiveKey="1"
                  className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                >
                  <Accordion.Item
                    eventKey={
                      this.context.selectedMenuItem === "marketing" ? "1" : "0"
                    }
                    className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                    onClick={(e) => {
                      this.context.selectedMenuItem = "marketing";
                    }}
                  >
                    <Accordion.Header className="mx-0 p-lg-0  text-start">
                      <Nav.Link
                        as={Link}
                        className="p-lg-0 bg-white border-0 text-dark text-start"
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        to=""
                      >
                        <SiCoinmarketcap size={20}></SiCoinmarketcap>
                        &nbsp;Marketing
                      </Nav.Link>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/ProductCatalog"
                      >
                        <RiCoupon5Line size="20" />
                        &nbsp; Product Catalog
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/BulkEmailCampaign"
                        // disabled={true}
                      >
                        <RiCoupon5Line size="20" />
                        &nbsp; Email Campaign
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/BulkWhatsappCampaign"
                        // disabled={true}
                      >
                        <RiCoupon5Line size="20" />
                        &nbsp; WhatsApp Campaign
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/BulkSmsCampaign"
                        // disabled={true}
                      >
                        <RiCoupon5Line size="20" />
                        &nbsp; SMS Campaign
                      </Nav.Link>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}

          {/* Sales */}
          {this.showSales() ? (
            <>
              {this.context.storeSettings.showSalesModule == true ||
              this.context.storeSettings.showSalesModule == undefined ? (
                <>
                  <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                    <Accordion
                      defaultActiveKey="1"
                      className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                    >
                      <Accordion.Item
                        eventKey={
                          this.context.selectedMenuItem === "sales" ? "1" : "0"
                        }
                        className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "sales";
                        }}
                      >
                        <Accordion.Header className="mx-0 p-lg-0  text-start">
                          <Nav.Link
                            className="p-lg-0 bg-white border-0 text-dark text-start"
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            to=""
                          >
                            <BsFillCartCheckFill size="20" />
                            {/* <FcSalesPerformance size="20" /> */}
                            {/* <i class="bi bi-basket"></i> */}
                            &nbsp;Sales
                          </Nav.Link>
                        </Accordion.Header>
                        <Accordion.Body>
                          {this.context.storeSettings.showLeadsModule == true ||
                          this.context.storeSettings.showLeadsModule ==
                            undefined ? (
                            <>
                              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                <Nav.Link
                                  as={Link}
                                  style={{
                                    color: "black",
                                    fontSize: "12px",
                                    fontFamily: "tahoma",
                                    fontWeight: "bold",
                                  }}
                                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                  to="/SalesLeads"
                                >
                                  <FaBuysellads size={20} />
                                  &nbsp;Leads Management
                                </Nav.Link>
                              </ListGroup.Item>
                            </>
                          ) : (
                            <></>
                          )}

                          {this.context.storeSettings.showQuoteModule == true ||
                          this.context.storeSettings.showQuoteModule ==
                            undefined ? (
                            <>
                              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                <Nav.Link
                                  as={Link}
                                  style={{
                                    color: "black",
                                    fontSize: "12px",
                                    fontFamily: "tahoma",
                                    fontWeight: "bold",
                                  }}
                                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                  to="/QuotationRequest"
                                >
                                  <BiSolidQuoteRight size="20" />
                                  &nbsp;Quotation Orders(QO)
                                </Nav.Link>
                              </ListGroup.Item>
                            </>
                          ) : (
                            <></>
                          )}
                          {this.context.storeSettings.showPosmodule == true ||
                          this.context.storeSettings.showPosmodule ==
                            undefined ? (
                            <>
                              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                <Nav.Link
                                  as={Link}
                                  style={{
                                    color: "black",
                                    fontSize: "12px",
                                    fontFamily: "tahoma",
                                    fontWeight: "bold",
                                  }}
                                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                  to="/SalesOrders"
                                >
                                  {/* <RiCoupon5Line size="20" /> */}
                                  <PiListNumbersFill size="20" />
                                  &nbsp;Sale Orders(SO)
                                </Nav.Link>
                              </ListGroup.Item>
                              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                <Nav.Link
                                  as={Link}
                                  style={{
                                    color: "black",
                                    fontSize: "12px",
                                    fontFamily: "tahoma",
                                    fontWeight: "bold",
                                  }}
                                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                  to={
                                    "https://" +
                                    this.context.store.storePosDomainName
                                  }
                                  target="_blank"
                                >
                                  <FaMoneyBillTrendUp size="20" />
                                  &nbsp;Billing POS - OUTWARD
                                </Nav.Link>
                              </ListGroup.Item>
                            </>
                          ) : (
                            <></>
                          )}

                          {this.context.storeSettings.showEcommerceModule ==
                            true ||
                          this.context.storeSettings.showEcommerceModule ==
                            undefined ? (
                            <>
                              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                <Nav.Link
                                  as={Link}
                                  style={{
                                    color: "black",
                                    fontSize: "12px",
                                    fontFamily: "tahoma",
                                    fontWeight: "bold",
                                  }}
                                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                  to={
                                    "https://" +
                                    this.context.store.storeDomainName
                                  }
                                  target="_blank"
                                >
                                  <SiCommerzbank size="20" />
                                  &nbsp;ECommerce / OnlineStore
                                </Nav.Link>
                              </ListGroup.Item>
                            </>
                          ) : (
                            <></>
                          )}

                          {this.context.storeSettings.showKioskModule == true ||
                          this.context.storeSettings.showKioskModule ==
                            undefined ? (
                            <>
                              <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                <Nav.Link
                                  as={Link}
                                  style={{
                                    color: "black",
                                    fontSize: "12px",
                                    fontFamily: "tahoma",
                                    fontWeight: "bold",
                                  }}
                                  className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                                  to={
                                    "https://" +
                                    this.context.store.storeDomainName +
                                    "/kiosk"
                                  }
                                  target="_blank"
                                >
                                  <FcSelfServiceKiosk size={20} />
                                  &nbsp;KIOSK
                                </Nav.Link>
                              </ListGroup.Item>
                            </>
                          ) : (
                            <></>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ListGroup.Item>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          {/* Orders */}
          {this.showOrders() ? (
            <>
              <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                <Accordion
                  defaultActiveKey="1"
                  className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                >
                  <Accordion.Item
                    eventKey={
                      this.context.selectedMenuItem === "orders" ? "1" : "0"
                    }
                    className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                    onClick={(e) => {
                      this.context.selectedMenuItem = "orders";
                    }}
                  >
                    <Accordion.Header className="mx-0 p-lg-0  text-start">
                      <Nav.Link
                        className="p-lg-0 bg-white border-0 text-dark text-start"
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        to=""
                        hidden={this.context.hideOrderToolbarIcon()}
                      >
                        <LiaFirstOrder size="20" />
                        &nbsp;Orders
                      </Nav.Link>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                        to="/OrdersDashboard"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "dashboard";
                        }}
                        hidden={this.context.hideNewOrders()}
                      >
                        <BiBarChart size={20}></BiBarChart>
                        &nbsp;Dashboard
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Orders"
                        hidden={this.context.hideNewOrders()}
                      >
                        <Row>
                          <Col md={8}>1. New Orders</Col>
                          <Col md={4}>
                            <GoListOrdered size="20" />
                            <Badge
                              bg="primary"
                              className="notify-badge-right1 text-white"
                            >
                              {this.context.orderSummary != ""
                                ? this.context.orderSummary.orderReceived
                                : ""}
                            </Badge>
                          </Col>
                        </Row>
                      </Nav.Link>

                      {this.context.store.businessTypeId == 3 ? (
                        <>
                          <Nav.Link
                            as={Link}
                            style={{
                              color: "black",
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/Kds2"
                            hidden={this.context.hidePackaingToolbarIcon()}
                          >
                            <Row>
                              <Col md={8}>2. Prepare</Col>
                              <Col md={4}>
                                <BsFullscreen size="20"></BsFullscreen>
                                <Badge
                                  bg="success"
                                  className="notify-badge-right1 text-white"
                                >
                                  {this.context.orderSummary != ""
                                    ? this.context.orderSummary.orderPrepare
                                    : ""}
                                </Badge>
                              </Col>
                            </Row>
                          </Nav.Link>
                        </>
                      ) : (
                        <>
                          <Nav.Link
                            as={Link}
                            style={{
                              color: "black",
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/Kds2"
                            hidden={this.context.hidePackaingToolbarIcon()}
                          >
                            <Row>
                              <Col md={8}>2. Prepare</Col>
                              <Col md={4}>
                                <BsFullscreen size="20"></BsFullscreen>
                                <Badge
                                  bg="success"
                                  className="notify-badge-right1 text-white"
                                >
                                  {this.context.orderSummary != ""
                                    ? this.context.orderSummary.orderPrepare
                                    : ""}
                                </Badge>
                              </Col>
                            </Row>
                          </Nav.Link>
                        </>
                      )}

                      <Nav.Link
                        as={Link}
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Package"
                        hidden={this.context.hidePackaingToolbarIcon()}
                      >
                        <Row>
                          <Col md={8}>3. Package</Col>
                          <Col md={4}>
                            <BsFillBagFill size="20" />
                            <Badge
                              bg="danger"
                              className="notify-badge-right1 text-white"
                            >
                              {this.context.orderSummary != ""
                                ? this.context.orderSummary.orderPackage
                                : ""}
                            </Badge>
                          </Col>
                        </Row>
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Dispatch"
                        hidden={this.context.hideShippingToolbarIcon()}
                      >
                        <Row>
                          <Col md={8}>4. Ship</Col>
                          <Col md={4}>
                            <BsTruck size="20" />
                            <Badge
                              bg="danger"
                              className="notify-badge-right1 text-white"
                            >
                              {this.context.orderSummary != ""
                                ? this.context.orderSummary.orderShip
                                : ""}
                            </Badge>
                          </Col>
                        </Row>
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Delivery"
                        hidden={this.context.hideDeliveryToolbarIcon()}
                      >
                        <Row>
                          <Col md={8}>5. Delivery</Col>
                          <Col md={4}>
                            <img
                              width="26px"
                              height="26px"
                              // className="invertimage"
                              style={{ objectFit: "contain", color: "white" }}
                              src="images/delivery.png"
                            />
                            <Badge
                              bg="danger"
                              className="notify-badge-right1 text-white"
                            >
                              {this.context.orderSummary != ""
                                ? this.context.orderSummary.orderDelivery
                                : ""}
                            </Badge>
                          </Col>
                        </Row>
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Payment"
                        hidden={this.context.hidePaymentToolbarIcon()}
                      >
                        <Row>
                          <Col md={8}>6. Payment</Col>
                          <Col md={4}>
                            <BsCashCoin size="20" />
                            <Badge
                              bg="danger"
                              className="notify-badge-right1 text-white"
                            >
                              {this.context.orderSummary != ""
                                ? this.context.orderSummary.orderPayment
                                : ""}
                            </Badge>
                          </Col>
                        </Row>
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CloseOrder"
                        hidden={this.context.hideClosedOrders()}
                      >
                        <Row>
                          <Col md={8}>7. Closed</Col>
                          <Col md={4}>
                            <BsDoorClosed size="20" />
                            <Badge
                              bg="warning"
                              className="notify-badge-right1 text-white"
                            >
                              {this.context.orderSummary != ""
                                ? this.context.orderSummary.orderClose
                                : ""}
                            </Badge>
                          </Col>
                        </Row>
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/OrderHistory"
                        hidden={this.context.hideClosedOrders()}
                      >
                        <Row>
                          <Col md={8}>8. History</Col>
                          <Col md={4}>
                            <BsClockHistory size="14" />
                            <Badge
                              bg="secondary"
                              className="notify-badge-right1 text-white"
                            >
                              {this.context.orderSummary != ""
                                ? this.context.orderSummary.orderHistory
                                : ""}
                            </Badge>
                          </Col>
                        </Row>
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Returns"
                        hidden={this.context.hideReturns()}
                      >
                        <Row>
                          <Col md={8}>9. Returns</Col>
                          <Col md={4}>
                            <BsArrowReturnLeft size="20" />
                            <Badge
                              bg="danger"
                              className="notify-badge-right1 text-white"
                            >
                              {this.context.orderSummary != ""
                                ? this.context.orderSummary.orderReturned
                                : ""}
                            </Badge>
                          </Col>
                        </Row>
                      </Nav.Link>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}

          {/* CRM */}
          {this.showCrm() ? (
            <>
              <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                <Accordion
                  defaultActiveKey="1"
                  className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                >
                  <Accordion.Item
                    eventKey={
                      this.context.selectedMenuItem === "customer" ? "1" : "0"
                    }
                    className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                    onClick={(e) => {
                      this.context.selectedMenuItem = "customer";
                    }}
                  >
                    <Accordion.Header className="mx-0 p-lg-0  text-start">
                      <Nav.Link
                        as={Link}
                        className="p-lg-0 bg-white border-0 text-dark text-start"
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        to=""
                      >
                        {/* <BsPeopleFill size="20" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-person-bounding-box"
                          viewBox="0 0 16 16"
                        >
                          <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5" />
                          <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                        </svg>
                        &nbsp;Customers
                      </Nav.Link>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Customers"
                      >
                        <BsPeopleFill size="20" />
                        &nbsp;Customer & Orders
                      </Nav.Link>

                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Coupon"
                      >
                        <RiCoupon5Line size="20" />
                        &nbsp;Coupons
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Feedbacks"
                        disabled={true}
                      >
                        <RiCoupon5Line size="20" />
                        &nbsp;Feedbacks & Ratings
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/Complaints"
                        disabled={true}
                      >
                        <RiCoupon5Line size="20" />
                        &nbsp;Complaints & Issues
                      </Nav.Link>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}

          {this.showCrm() ? (
            <>
              <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                <Accordion
                  defaultActiveKey="1"
                  className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                >
                  <Accordion.Item
                    eventKey={
                      this.context.selectedMenuItem === "customer" ? "1" : "0"
                    }
                    className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                    onClick={(e) => {
                      this.context.selectedMenuItem = "customer";
                    }}
                  >
                    <Accordion.Header className="mx-0 p-lg-0  text-start">
                      <Nav.Link
                        as={Link}
                        className="p-lg-0 bg-white border-0 text-dark text-start"
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        to=""
                      >
                        {/* <BsPeopleFill size="20" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-person-bounding-box"
                          viewBox="0 0 16 16"
                        >
                          <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5" />
                          <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                        </svg>
                        &nbsp;Hospitals(CRM)
                      </Nav.Link>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmDashboard"
                      >
                        <FcWorkflow size="20" />
                        &nbsp;CRM Dashboard
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmContacts"
                      >
                        <FaUsers size="20" />
                        &nbsp;Contacts
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmLeads"
                      >
                        <FaBuysellads size="20" />
                        &nbsp;Leads
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmAppointments"
                      >
                        <BsFillCalendarFill size="20" />
                        &nbsp;Appointments
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmCases"
                      >
                        <FaFileInvoice size="20" />
                        &nbsp;Cases
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmInvoices"
                      >
                        <TbReceiptTax size="20" />
                        &nbsp;Invoices
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmRoles"
                      >
                        <FaUserShield size="20" />
                        &nbsp;Roles
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmUsers"
                      >
                        <FaUserFriends size="20" />
                        &nbsp;Users
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmServicePlans"
                      >
                        <FaClipboardList size="20" />
                        &nbsp;Service Plans
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmTags"
                      >
                        <FaTags size="20" />
                        &nbsp;Tags
                      </Nav.Link>
                      <Nav.Link
                        as={Link}
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                        to="/CrmActivities"
                      >
                        <TbReportAnalytics size="20" />
                        &nbsp;Activities
                      </Nav.Link>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}

          {/* HRM */}
          {this.showHrm() ? (
            <>
              {this.context.storeSettings.showHrmModule == true ? (
                <>
                  <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                    <Accordion
                      defaultActiveKey="1"
                      className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                    >
                      <Accordion.Item
                        eventKey={
                          this.context.selectedMenuItem === "hrm" ? "1" : "0"
                        }
                        className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "hrm";
                        }}
                      >
                        <Accordion.Header className="mx-0 p-lg-0  text-start">
                          <Nav.Link
                            as={Link}
                            className="p-lg-0 bg-white border-0 text-dark text-start"
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            to=""
                          >
                            <FaUsers size={22} />
                            &nbsp;Employees (HRM)
                          </Nav.Link>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/Departments"
                          >
                            <BsPeopleFill size="20" />
                            &nbsp;Departments
                          </Nav.Link>
                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/Employees"
                          >
                            <BsPeopleFill size="20" />
                            &nbsp;Employee DB
                          </Nav.Link>

                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/EmployeeTimesheet"
                          >
                            <RiCoupon5Line size="20" />
                            &nbsp;Employee Timesheet
                          </Nav.Link>
                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/EmployeeAbsence"
                          >
                            <BsPeopleFill size="20" />
                            &nbsp;Employee Leave
                          </Nav.Link>
                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/EmployeeActions"
                          >
                            <BsPeopleFill size="20" />
                            &nbsp;Employee Actions
                          </Nav.Link>
                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/EmployeeRequests"
                          >
                            <BsPeopleFill size="20" />
                            &nbsp;Employee Requests
                          </Nav.Link>
                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/EmployeePerformance"
                          >
                            <BsPeopleFill size="20" />
                            &nbsp;Employee Performance
                          </Nav.Link>

                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/Employees"
                          >
                            <BsPeopleFill size="20" />
                            &nbsp;Employee Onboarding
                          </Nav.Link>
                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/Employees"
                          >
                            <BsPeopleFill size="20" />
                            &nbsp;Employee Exit/Resign
                          </Nav.Link>
                          <Nav.Link
                            as={Link}
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                            to="/EmployeeHolidayCalendar"
                          >
                            <RiCoupon5Line size="20" />
                            &nbsp;Holidays Calender
                          </Nav.Link>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ListGroup.Item>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          {/* Projects */}
          {this.showProjects() ? (
            <>
              {this.context.storeSettings.showFinanceModule == true ? (
                <>
                  <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                    <Accordion
                      defaultActiveKey="1"
                      className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                    >
                      <Accordion.Item
                        eventKey={
                          this.context.selectedMenuItem === "project"
                            ? "1"
                            : "0"
                        }
                        className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "project";
                        }}
                      >
                        <Accordion.Header className="mx-0 p-lg-0  text-start">
                          <Nav.Link
                            as={Link}
                            className="p-lg-0 bg-white border-0 text-dark text-start"
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            to=""
                          >
                            <FaProjectDiagram size="20" />
                            &nbsp;Projects
                          </Nav.Link>
                        </Accordion.Header>
                        <Accordion.Body>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/ProjectManagement"
                            >
                              <FaProjectDiagram size="20" />
                              &nbsp;Projects
                            </Nav.Link>
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/ProjectTasks"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Project WorkItems
                            </Nav.Link>
                            <Nav.Link
                              as={Link}
                              disabled
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/ProjectTasks"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Project Backlogs
                            </Nav.Link>
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/ProjectRisks"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Project Risks
                            </Nav.Link>
                          </ListGroup.Item>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ListGroup.Item>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          {/* Accounts */}
          {this.showAccounts() ? (
            <>
              {this.context.storeSettings.showFinanceModule == true ? (
                <>
                  <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                    <Accordion
                      defaultActiveKey="1"
                      className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                    >
                      <Accordion.Item
                        eventKey={
                          this.context.selectedMenuItem === "account"
                            ? "1"
                            : "0"
                        }
                        className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "account";
                        }}
                      >
                        <Accordion.Header className="mx-0 p-lg-0  text-start">
                          <Nav.Link
                            as={Link}
                            className="p-lg-0 bg-white border-0 text-dark text-start"
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            to="/AccountingDashboard"
                          >
                            <BsCashCoin size={20} />
                            &nbsp;Accounting
                          </Nav.Link>
                        </Accordion.Header>
                        <Accordion.Body>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/AccountingDashboard"
                            >
                              <MdDashboard size={20} />
                              &nbsp;Dashboard
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/AccountExpensesCategorys"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Account Category
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/AccountExpenses"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Debits [Expenses/Outflows]
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/AccountRevenues"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Credits [Revenues/Inflows]
                            </Nav.Link>
                          </ListGroup.Item>

                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/AccountReceiveables"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Receivable (AR)
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/AccountPayables"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Payable (AP)
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/AccountPayroll"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Employee Payroll
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/BankAccountManagement"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Bank Accounts
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/BankRecoPage"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Bank Reconciliation
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/LedgerBook"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;LedgerBook
                            </Nav.Link>
                          </ListGroup.Item>

                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/AccountLedger"
                            >
                              <BsPeopleFill size="20" />
                              &nbsp;Ledger Summary
                            </Nav.Link>
                          </ListGroup.Item>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ListGroup.Item>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          {/* Storage */}
          {this.ShowStorage() ? (
            <>
              {this.context.storeSettings.showStorageModule == true ||
              this.context.storeSettings.showStorageModule == undefined ? (
                <>
                  <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                    <Nav.Link
                      as={Link}
                      style={{
                        fontSize: "12px",
                        fontFamily: "tahoma",
                        fontWeight: "bold",
                      }}
                      className="w-100 py-2 my-2 mb-0 bg-white border-0 text-dark text-start"
                      to="/Images"
                    >
                      <TiCloudStorage size="20" />
                      &nbsp;Storage Drive
                    </Nav.Link>
                  </ListGroup.Item>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          {/* eCommerce Settings */}
          {this.showCrm() ? (
            <>
              {this.context.storeSettings.showEcommerceModule == true ||
              this.context.storeSettings.showEcommerceModule == undefined ? (
                <>
                  <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                    <Accordion
                      defaultActiveKey="1"
                      className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                    >
                      <Accordion.Item
                        eventKey={
                          this.context.selectedMenuItem === "portalsettings"
                            ? "1"
                            : "0"
                        }
                        className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "portalsettings";
                        }}
                      >
                        <Accordion.Header className="mx-0 p-lg-0  text-start">
                          <Nav.Link
                            as={Link}
                            className="p-lg-0 bg-white border-0 text-dark text-start"
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            to=""
                          >
                            <BsFillLaptopFill size="20" />
                            &nbsp;ECommerce Settings
                          </Nav.Link>
                        </Accordion.Header>
                        <Accordion.Body>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/HomeSettingsCarousel"
                            >
                              <BsFillFileImageFill size="20" />
                              &nbsp;Home Carosel Images
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/HomeSettingsMainMenu"
                            >
                              <BsMenuDown size="20" />
                              &nbsp;Main-Menu Configuration
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/HomeSettingsTop5Ads"
                            >
                              <BsMenuDown size="20" />
                              &nbsp;Top Ads
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/ClientCertificate"
                            >
                              <BsMenuDown size="20" />
                              &nbsp;Certificates
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/ClientLogo"
                            >
                              <BsMenuDown size="20" />
                              &nbsp;Client Logos
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/ClientTestimonial"
                            >
                              <BsMenuDown size="20" />
                              &nbsp;Testimonials
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/ClientDisplayCounter"
                            >
                              <BsMenuDown size="20" />
                              &nbsp;Display Counters
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/HomeSettingsVlog"
                            >
                              <BsMenuDown size="20" />
                              &nbsp;Vlogs
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/HomeSettingsBlog"
                            >
                              <BsMenuDown size="20" />
                              &nbsp;Blogs
                            </Nav.Link>
                          </ListGroup.Item>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                              to="/Themes"
                            >
                              <BsMenuDown size="20" />
                              &nbsp;Themes
                            </Nav.Link>
                          </ListGroup.Item>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ListGroup.Item>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          {/* Admin */}
          {this.ShowAdminMenu() ? (
            <>
              <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                <Accordion
                  defaultActiveKey="1"
                  className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                >
                  <Accordion.Item
                    eventKey={
                      this.context.selectedMenuItem === "admin" ? "1" : "0"
                    }
                    className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                    onClick={(e) => {
                      this.context.selectedMenuItem = "admin";
                    }}
                  >
                    <Accordion.Header className="mx-0 p-lg-0  text-start">
                      <Nav.Link
                        as={Link}
                        className="p-lg-0 bg-white border-0 text-dark text-start"
                        style={{
                          fontSize: "12px",
                          fontFamily: "tahoma",
                          fontWeight: "bold",
                        }}
                        to=""
                      >
                        <BsPersonSquare size="20" />
                        &nbsp;Admin Settings
                      </Nav.Link>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/Users"
                        >
                          <BsPersonCheckFill size="20" />
                          &nbsp;Admin Portal Users
                        </Nav.Link>
                      </ListGroup.Item>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/PosUsers"
                        >
                          <BsPersonCheckFill size="20" />
                          &nbsp;POS Portal Users
                        </Nav.Link>
                      </ListGroup.Item>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/LoyaltyPointConfig"
                        >
                          <BsPersonCheckFill size="20" />
                          &nbsp;Loyalty Point Configuration
                        </Nav.Link>
                      </ListGroup.Item>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/ShippingConfig"
                        >
                          <BsTruck size="20" />
                          &nbsp;Shipping / Delivery
                        </Nav.Link>
                      </ListGroup.Item>
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/TaxesConfig"
                        >
                          <TbReceiptTax size="20" />
                          &nbsp;Taxes
                        </Nav.Link>
                      </ListGroup.Item>
                      {this.context.store.businessTypeId == 3 ? (
                        <>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/RestaurantTables"
                            >
                              <TbReceiptTax size="20" />
                              &nbsp;Retaurant Tables
                            </Nav.Link>
                          </ListGroup.Item>
                        </>
                      ) : (
                        ""
                      )}
                      <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/MultiCurrencys"
                        >
                          <TbReceiptTax size="20" />
                          &nbsp;Multi Country & Currency Settings
                        </Nav.Link>
                      </ListGroup.Item>

                      <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                        <Nav.Link
                          as={Link}
                          style={{
                            fontSize: "12px",
                            fontFamily: "tahoma",
                            fontWeight: "bold",
                          }}
                          className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                          to="/StoreSettings"
                        >
                          <TbBuildingStore size="20" />
                          &nbsp;Settings
                        </Nav.Link>
                      </ListGroup.Item>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}

          {this.ShowProductAdminMenu() ? (
            <>
              {this.context.UserRoles.PRODUCTADMIN ==
              this.context.userData.roleId ? (
                <>
                  <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                    <Accordion
                      defaultActiveKey="1"
                      className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                    >
                      <Accordion.Item
                        eventKey={
                          this.context.selectedMenuItem === "admin" ? "1" : "0"
                        }
                        className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "admin";
                        }}
                      >
                        <Accordion.Header className="mx-0 p-lg-0  text-start">
                          <Nav.Link
                            as={Link}
                            className="p-lg-0 bg-white border-0 text-dark text-start"
                            style={{
                              fontSize: "12px",
                              fontFamily: "tahoma",
                              fontWeight: "bold",
                            }}
                            to=""
                          >
                            <BsPersonSquare size="20" />
                            &nbsp;ProductSupport
                          </Nav.Link>
                        </Accordion.Header>
                        <Accordion.Body>
                          <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                            <Nav.Link
                              as={Link}
                              style={{
                                fontSize: "12px",
                                fontFamily: "tahoma",
                                fontWeight: "bold",
                              }}
                              className="w-100 py-2 my-2 mb-0 bg-white border-0 text-secondary text-start"
                              to="/ProductThemes"
                            >
                              <BsPersonCheckFill size="20" />
                              &nbsp;Product Themes
                            </Nav.Link>
                          </ListGroup.Item>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </ListGroup.Item>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            <></>
          )}

          {window.location.hostname == "lifestyleaqua-admin.elasticcart.com" ? (
            <>
              <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                <Nav.Link
                  as={Link}
                  style={{
                    fontSize: "12px",
                    fontFamily: "tahoma",
                    fontWeight: "bold",
                  }}
                  className="w-100 py-2 my-1 mb-0 bg-white border-0 text-secondary text-start"
                  to="/LifeStyleAquaAuthenticator"
                >
                  <BsFillFileImageFill size="20" />
                  &nbsp;Authenticator
                </Nav.Link>
              </ListGroup.Item>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
}
